// Replaces the WoodMart/Elementor/WooCommerce scripts the reference loads: load-time classes, side panels,
// menus, sticky header, predictive search, cart panel, footer collapse, scroll-to-top, cookie popup.
(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];

  // Load-time state the reference scripts set (WooCommerce, Elementor)
  document.body.classList.replace('woocommerce-no-js', 'woocommerce-js');
  if (/Chrome|Chromium|Edg\//.test(navigator.userAgent)) document.body.classList.add('e--ua-blink', 'e--ua-webkit');
  $$('.e-con').forEach((el) => el.classList.add('e-lazyloaded'));   // Elementor lazy backgrounds

  // Contact Form 7 load-time state, form result state, and default:get prefill
  $$('.wpcf7.no-js').forEach((el) => el.classList.replace('no-js', 'js'));
  $$('.wpcf7-submit.has-spinner').forEach((b) => b.insertAdjacentHTML('afterend', '<span class="wpcf7-spinner"></span>'));
  $$('[data-yc-form-state]').forEach((i) => { const f = i.form; if (f) { f.classList.add(i.value); f.dataset.status = i.value; } });
  // Product gallery: the state WoodMart's Swiper carousel sets (initialised classes, slide sizes, active slide,
  // vertical thumbnails beside the image on desktop), with arrows and thumbnail clicks.
  $$('.woocommerce-product-gallery').forEach((gallery) => {
    const main = $('.wd-gallery-images .wd-carousel', gallery), thumbs = $('.wd-gallery-thumb .wd-carousel', gallery);
    if (!main) return;
    const slides = $$('.wd-carousel-wrap > .wd-carousel-item', main), tItems = thumbs ? $$('.wd-carousel-wrap > .wd-carousel-item', thumbs) : [];
    // --wd-col is the column count WoodMart's CSS resolves for the current breakpoint (phone up to 768.98px)
    const cols = (el) => { const cs = getComputedStyle(el); const w = innerWidth; return Number(cs.getPropertyValue('--wd-col')) || Number(cs.getPropertyValue(w >= 1025 ? '--wd-col-lg' : w >= 769 ? '--wd-col-md' : '--wd-col-sm')) || 1; };
    const vertical = () => gallery.classList.contains('thumbs-position-left') && innerWidth >= 1025;
    let index = 0;
    const arrows = (box, at, last) => {   // wd-lock hides both arrows when everything fits (Swiper watchOverflow)
      $$('.wd-btn-arrow', box).forEach((btn) => btn.classList.toggle('wd-lock', last <= 0));
      $('.wd-btn-arrow.wd-prev', box)?.classList.toggle('wd-disabled', at <= 0); $('.wd-btn-arrow.wd-next', box)?.classList.toggle('wd-disabled', at >= last);
    };
    const layout = () => {
      main.classList.add('wd-initialized', 'wd-horizontal', 'wd-backface-hidden');
      const w = main.clientWidth;
      slides.forEach((s, i) => { s.style.width = `${w}px`; s.classList.toggle('wd-active', i === index); s.classList.toggle('wd-slide-next', i === index + 1); s.classList.toggle('wd-slide-prev', i === index - 1); });
      const wrap = $('.wd-carousel-wrap', main); wrap.style.cursor = 'grab'; wrap.style.transform = index ? `translate3d(${-index * w}px, 0px, 0px)` : '';
      arrows(main.closest('.wd-carousel-container'), index, slides.length - 1);
      if (!thumbs) return;
      const n = cols(thumbs), v = vertical();
      thumbs.classList.add('wd-initialized', 'wd-watch-progress', 'wd-backface-hidden', 'wd-thumbs');
      thumbs.classList.toggle('wd-vertical', v); thumbs.classList.toggle('wd-horizontal', !v);
      const first = Math.min(Math.max(0, index - n + 1), Math.max(0, tItems.length - n));
      const size = v ? thumbs.clientHeight / n : thumbs.clientWidth / n;   // WoodMart: column height / visible count
      tItems.forEach((t, i) => {
        t.style.width = v ? '' : `${size}px`; t.style.height = v ? `${size}px` : '';
        const vis = i >= first && i < first + n;
        t.className = ['wd-carousel-item', vis && 'wd-slide-visible wd-full-visible', i === index && 'wd-active wd-thumb-active', i === index + 1 && 'wd-slide-next'].filter(Boolean).join(' ');
      });
      const tw = $('.wd-carousel-wrap', thumbs); tw.style.cursor = 'grab';
      tw.style.transform = !first ? '' : v ? `translate3d(0px, ${-first * size}px, 0px)` : `translate3d(${-first * size}px, 0px, 0px)`;
      arrows(thumbs.closest('.wd-carousel-container'), first, Math.max(0, tItems.length - n));
    };
    const go = (i) => { index = Math.max(0, Math.min(slides.length - 1, i)); layout(); };
    gallery.addEventListener('click', (e) => {
      const arrow = e.target.closest('.wd-btn-arrow'); const th = e.target.closest('.wd-gallery-thumb .wd-carousel-item');
      if (arrow) { e.preventDefault(); go(index + (arrow.classList.contains('wd-next') ? 1 : -1)); }
      else if (th) { e.preventDefault(); go(tItems.indexOf(th)); }
    });
    layout(); addEventListener('resize', layout);
  });

  // Product tabs (WoodMart singleProductTabsAccordion): accordion at 1024px and below, tabs above;
  // the active panel is opened (display:block). The accordion title toggles its panel.
  $$('.woocommerce-tabs').forEach((tabs) => {
    const panels = $$('.woocommerce-Tabs-panel', tabs);
    const apply = () => {
      const acc = innerWidth <= 1024;
      tabs.classList.toggle('wc-tabs-wrapper', !acc); tabs.classList.toggle('tabs-layout-tabs', !acc);
      const page = tabs.closest('.single-product-page');
      if (page) { page.classList.toggle('tabs-type-tabs', !acc); page.classList.toggle('tabs-type-accordion', acc); }
      ['tabs-layout-accordion', 'wd-accordion', 'wd-style-default', 'wd-inited'].forEach((c) => tabs.classList.toggle(c, acc));
      panels.forEach((p) => { p.classList.toggle('wd-accordion-content', acc); p.classList.toggle('wd-scroll', acc); if (p.classList.contains('wd-active')) p.style.display = 'block'; });
    };
    tabs.addEventListener('click', (e) => {
      const title = e.target.closest('.wd-accordion-title'); if (!title) return;
      const panel = $(`#${title.id.replace('tab-item-title-', 'tab-')}`, tabs); if (!panel) return;
      const open = !title.classList.contains('wd-active');
      title.classList.toggle('wd-active', open); panel.classList.toggle('wd-active', open); panel.style.display = open ? 'block' : 'none';
    });
    apply(); addEventListener('resize', apply);
  });

  // WooCommerce review form: the rating <select> becomes five clickable stars (single-product.js)
  $$('#review_form #rating, .comment-form-rating select#rating').forEach((select) => {
    if (select.previousElementSibling?.classList.contains('stars')) return;
    const p = document.createElement('p'); p.className = 'stars';
    const span = document.createElement('span'); span.setAttribute('role', 'group'); span.setAttribute('aria-labelledby', 'comment-form-rating-label');
    for (let i = 1; i <= 5; i++) {
      const a = document.createElement('a'); a.setAttribute('role', 'radio'); a.tabIndex = i === 1 ? 0 : -1; a.setAttribute('aria-checked', 'false');
      a.className = `star-${i}`; a.href = '#'; a.textContent = `${i} of 5 stars`;
      a.addEventListener('click', (e) => { e.preventDefault(); select.value = String(i); p.classList.add('selected');
        span.querySelectorAll('a').forEach((x) => { x.classList.toggle('active', x === a); x.setAttribute('aria-checked', String(x === a)); }); });
      span.append(' ', a);
    }
    span.append(' '); p.append(' ', span, ' ');
    select.before(p); select.style.display = 'none';
  });
  // CF7 acceptance: submit stays disabled until the consent box is ticked
  $$('form.wpcf7-form').forEach((f) => {
    const boxes = $$('.wpcf7-acceptance input[type="checkbox"]', f), submit = $('.wpcf7-submit', f);
    if (!boxes.length || !submit) return;
    const sync = () => { submit.disabled = !boxes.every((b) => b.checked); };
    boxes.forEach((b) => b.addEventListener('change', sync)); sync();
  });
  const qs = new URLSearchParams(location.search);
  [['contact[Size]', 'size'], ['contact[Condition]', 'condition'], ['contact[Container]', 'container'], ['contact[ZIP]', 'zip']].forEach(([n, k]) => {
    const el = document.querySelector(`[name="${n}"]`); if (el && qs.get(k)) el.value = qs.get(k);
  });

  const closeSide = () => $('.wd-close-side');
  const open = (el) => {
    if (!el) return;
    el.classList.add('wd-opened'); closeSide()?.classList.add('wd-close-side-opened');
    const form = el.querySelector('form.hidden-form'); if (form) { form.classList.remove('hidden-form'); form.style.display = ''; }
  };
  const closeAll = () => {
    $$('.wd-side-hidden.wd-opened, .wd-show-sidebar-btn.wd-opened, .wd-sidebar-opener.wd-opened, .wd-toolbar-sidebar.wd-opened').forEach((e) => e.classList.remove('wd-opened'));
    closeSide()?.classList.remove('wd-close-side-opened');
  };

  // Side panels: mobile nav, cart, login
  document.addEventListener('click', (e) => {
    // (login opener is not intercepted: new customer accounts sign in on Shopify's own page, so the link navigates)
    const t = e.target.closest('.wd-header-mobile-nav > a, .cart-widget-opener > a, .wd-close-side, .close-side-widget a');
    if (!t) return;
    e.preventDefault();
    if (t.closest('.wd-close-side, .close-side-widget')) return closeAll();
    if (t.closest('.wd-header-mobile-nav')) return open($('.mobile-nav'));
    if (t.closest('.cart-widget-opener')) return open($('.cart-widget-side'));
    if (t.closest('.login-side-opener')) return open($('.login-form-side'));
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  // Shop sidebar (WoodMart hiddenSidebar.js): at load, an off-canvas panel on the widths the layout hides it;
  // "Show sidebar", the toolbar's Filters item and sidebar openers toggle it.
  const layoutWrap = $('.wd-content-layout'), sidebar = $('.wd-sidebar');
  if (layoutWrap && sidebar) {
    const w = innerWidth, has = (c) => layoutWrap.classList.contains(c);
    if ((has('wd-sidebar-hidden-lg') && w > 1024) || (has('wd-sidebar-hidden-md-sm') && w <= 1024 && w > 768) || (has('wd-sidebar-hidden-sm') && w <= 768)) {
      sidebar.classList.add('wd-side-hidden', 'wd-left', 'wd-scroll');
      $('.widget-area', sidebar)?.classList.add('wd-scroll-content');
    }
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('.wd-show-sidebar-btn, .wd-sidebar-opener, .wd-toolbar-sidebar');
    if (!t || !sidebar) return;
    e.preventDefault();
    if (sidebar.classList.contains('wd-opened')) closeAll();
    else { t.classList.add('wd-opened'); open(sidebar); }
  });

  // Mobile nav tabs (pages / categories) and submenu openers
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('.mobile-tab-title');
    if (tab) {
      e.preventDefault();
      $$('.mobile-tab-title').forEach((x) => x.classList.toggle('wd-active', x === tab));
      const which = tab.classList.contains('mobile-categories-title') ? 'categories' : 'pages';
      $$('.mobile-nav .wd-nav-mobile').forEach((m) => m.classList.toggle('wd-active', m.classList.contains(`mobile-${which}-menu`)));
    }
    const opener = e.target.closest('.wd-nav-opener');
    if (opener) { e.preventDefault(); opener.classList.toggle('wd-active'); opener.parentElement.querySelector('.wd-sub-menu')?.classList.toggle('wd-opened'); }
  });

  // Desktop dropdowns: hover/focus opens
  $$('.wd-nav > li.menu-item-has-children, .wd-header-cats').forEach((li) => {
    const on = () => li.classList.add('wd-opened'), off = () => li.classList.remove('wd-opened');
    li.addEventListener('mouseenter', on); li.addEventListener('mouseleave', off);
    li.addEventListener('focusin', on); li.addEventListener('focusout', (e) => { if (!li.contains(e.relatedTarget)) off(); });
  });

  // Sticky clone header (WoodMart headerBuilder, scroll-slide + sticky-clone + hide-on-scroll): the clone gets
  // whb-sticked past the main header's height, and whb-scroll-up / whb-scroll-down while scrolling.
  const header = $('.whb-header'), clone = $('.whb-clone');
  if (header && clone) {
    const h = header.querySelector('.whb-main-header')?.offsetHeight || 0;
    const hide = clone.classList.contains('whb-hide-on-scroll');
    let stuck = false, last = scrollY;
    addEventListener('scroll', () => {
      const a = scrollY, vh = innerHeight, dh = document.documentElement.scrollHeight;
      if (a > h) { if (!stuck) { stuck = true; clone.classList.add('whb-sticked'); } } else if (stuck) { stuck = false; clone.classList.remove('whb-sticked'); }
      if (hide) {
        if (last - a > 0 && a > h) { clone.classList.add('whb-scroll-up'); clone.classList.remove('whb-scroll-down'); }
        else if (a - last > 0 && a + vh !== dh && a > h + 100) { clone.classList.add('whb-scroll-down'); clone.classList.remove('whb-scroll-up'); }
        else if (a <= h) clone.classList.remove('whb-scroll-down', 'whb-scroll-up');
        else if (a + vh >= dh - 5) { clone.classList.add('whb-scroll-up'); clone.classList.remove('whb-scroll-down'); }
      }
      last = a;
    }, { passive: true });
  }

  // Predictive search into WoodMart's results dropdown markup
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  $$('form.searchform').forEach((form) => {
    const input = $('input[name="q"]', form), box = form.parentElement.querySelector('.wd-search-results');
    if (!input || !box) return;
    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 3) { box.innerHTML = ''; form.parentElement.classList.remove('wd-searched'); return; }
      timer = setTimeout(async () => {
        const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10`);
        const items = (await r.json()).resources.results.products;
        box.innerHTML = items.length
          ? items.map((p) => `<div class="wd-suggestion"><a class="wd-fill" href="${esc(p.url)}"></a><div class="wd-suggestion-thumb"><img src="${esc(p.image || '')}" alt=""></div><div class="wd-suggestion-content"><h4 class="wd-entities-title">${esc(p.title)}</h4><p class="price"><span class="woocommerce-Price-amount amount">$${Number(p.price).toFixed(2)}</span></p></div></div>`).join('')
            + `<div class="wd-search-results-wrapper"><a href="/search?q=${encodeURIComponent(q)}&type=product" class="wd-all-results">View all results</a></div>`
          : '<div class="wd-suggestion wd-not-found">No products found</div>';
        form.parentElement.classList.add('wd-searched');
      }, 250);
    });
  });

  // Re-render header, toolbar and cart panel sections after a cart change
  const refresh = async () => {
    const html = await (await fetch('/?sections=header,cart-side,toolbar')).json();
    for (const [id, markup] of Object.entries(html)) { const el = document.getElementById('shopify-section-' + id); if (el) el.outerHTML = markup; }
  };
  window.ycRefreshCart = refresh;
  window.ycOpenCart = () => open($('.cart-widget-side'));
  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-cart-remove]'); if (!rm) return;
    e.preventDefault();
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: rm.dataset.cartRemove, quantity: 0 }) });
    await refresh(); open($('.cart-widget-side'));
  });

  // Shop filters: counts like yc_filter_count() (other groups' active filters applied), zero options hidden,
  // submit → Shopify tag URL /collections/<handle>/tag1+tag2 (a group with several ticks = any).
  $$('form[data-yc-filters]').forEach(async (form) => {
    const groups = $$('fieldset', form).map((fs) => $$('input[data-tag]', fs));
    const activeIn = (inputs) => inputs.filter((i) => i.checked).map((i) => i.dataset.tag);
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const tags = groups.map(activeIn).filter((t) => t.length === 1).map((t) => t[0]);
      const sort = new URLSearchParams(location.search).get('sort_by');
      location.href = `/collections/${form.dataset.collection}${tags.length ? '/' + tags.join('+') : ''}${sort ? '?sort_by=' + sort : ''}`;
    });
    let products = [];
    for (let page = 1; page < 5; page++) {
      const r = await fetch(`/collections/${form.dataset.collection}/products.json?limit=250&page=${page}`);
      const batch = (await r.json()).products || [];
      products = products.concat(batch.map((p) => (Array.isArray(p.tags) ? p.tags : String(p.tags).split(', '))));
      if (batch.length < 250) break;
    }
    groups.forEach((inputs, gi) => {
      const others = groups.map(activeIn).filter((t, i) => i !== gi && t.length);
      for (const input of inputs) {
        const n = products.filter((tags) => tags.includes(input.dataset.tag) && others.every((any) => any.some((t) => tags.includes(t)))).length;
        const li = input.closest('li');
        if (!n && !input.checked) { li.remove(); continue; }
        li.querySelector('[data-count-for]').textContent = n;
      }
    });
  });
  $$('form.woocommerce-ordering select.orderby').forEach((s) => s.addEventListener('change', () => s.form.submit()));

  // Cart page: "Change address" calculator recalculates the delivery estimate for the chosen state,
  // "Update cart" enables after a quantity change, coupon → Shopify discount link.
  const calc = $('form.woocommerce-shipping-calculator');
  if (calc) {
    const rates = (document.querySelector('[data-yc-rates]')?.dataset.ycRates || '').split('\n').map((l) => l.split('|'));
    const money = (n) => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    $('.shipping-calculator-button', calc)?.addEventListener('click', (e) => {
      e.preventDefault(); const f = $('.shipping-calculator-form', calc); const open = f.style.display === 'none';
      f.style.display = open ? '' : 'none'; e.currentTarget.setAttribute('aria-expanded', String(open));
    });
    calc.addEventListener('submit', async (e) => {
      e.preventDefault();
      const state = $('#calc_shipping_state', calc).value; const zone = rates.find((r) => (r[1] || '').split(',').includes(state));
      const cart = await (await fetch('/cart.js')).json();
      const classes = Object.fromEntries((document.querySelector('[data-yc-classes]')?.dataset.ycClasses || '').split(';').map((p) => p.split('=')));
      let ship = 0;
      for (const it of cart.items) ship += (zone ? Number(classes[it.key] === 'container-40' ? zone[3] : zone[2]) : 0) * it.quantity;
      const shipEl = $('[data-yc-ship]'); if (shipEl) shipEl.innerHTML = `<bdi><span class="woocommerce-Price-currencySymbol" translate="no">$</span>${money(ship)}</bdi>`;
      const totalEl = $('[data-yc-total]'); if (totalEl) totalEl.innerHTML = `<bdi><span class="woocommerce-Price-currencySymbol" translate="no">$</span>${money(cart.total_price / 100 + ship)}</bdi>`;
      const st = $('[data-yc-ship-state]'); if (st) st.textContent = state;
      $('.shipping-calculator-form', calc).style.display = 'none';
    });
  }
  const cartForm = $('form.woocommerce-cart-form');
  if (cartForm) {
    const upd = $('button[name="update"]', cartForm);
    cartForm.addEventListener('change', (e) => { if (e.target.matches('input.qty') && upd) upd.disabled = false; });
    $('button[name="apply_coupon"]', cartForm)?.addEventListener('click', (e) => {
      e.preventDefault(); const code = $('#coupon_code', cartForm).value.trim();
      if (code) location.href = `/discount/${encodeURIComponent(code)}?redirect=/cart`;
    });
  }

  // Footer widget collapse (WoodMart widgetCollapse) on small screens
  if (matchMedia('(max-width: 768px)').matches) $$('.wd-footer .widget').forEach((w) => w.classList.add('wd-widget-collapse'));
  document.addEventListener('click', (e) => { const t = e.target.closest('.wd-widget-collapse .widget-title'); if (t) t.parentElement.classList.toggle('wd-opened'); });

  // Scroll to top
  const top = $('.scrollToTop');
  if (top) {
    addEventListener('scroll', () => top.classList.toggle('button-show', scrollY > 100), { passive: true });
    top.addEventListener('click', (e) => { e.preventDefault(); scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  // Cookie popup → Shopify Customer Privacy API
  const pop = $('.wd-cookies-popup');
  if (pop) {
    if (!document.cookie.includes('yc_cookies=')) pop.classList.add('popup-display');
    $('.cookies-accept-btn', pop)?.addEventListener('click', (e) => {
      e.preventDefault();
      document.cookie = `yc_cookies=accepted;path=/;max-age=${60 * 60 * 24 * 60}`;
      pop.classList.remove('popup-display'); pop.classList.add('popup-hide');
      window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], () =>
        window.Shopify.customerPrivacy?.setTrackingConsent({ analytics: true, marketing: false, preferences: true, sale_of_data: false }, () => {}));
    });
  }
})();
